import { formatTimestampHuman } from "../date-utils";
export const customFieldSchemaDtoFields = [{
        name: "_fieldName",
        title: "Nome Campo",
        render: (x) => x.customFieldSchema.fieldName
    }, {
        name: "_fieldType",
        title: "Tipo campo",
        render: (x) => x.customFieldType.description
    }, {
        name: "_fieldLabel",
        title: "Label campo",
        render: (x) => x.customFieldSchema.fieldLabel
    }, {
        name: "_description",
        title: "Descrizione",
        render: (x) => x.customFieldSchema.description
    }, {
        name: "_row",
        title: "Riga",
        render: (x) => x.customFieldSchema.detailDisplayRow
    }, {
        name: "_col",
        title: "Colonna",
        render: (x) => x.customFieldSchema.detailDisplayCol
    }, {
        name: "_listable",
        title: "Visibile (liste)",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.customFieldSchema.listable === 1 ? "check" : "close"}</i>`
    }, {
        name: "_visible",
        title: "Visibile (dettaglio)",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.customFieldSchema.visible === 1 ? "check" : "close"}</i>`
    }, {
        name: "_editable",
        title: "Editabile",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.customFieldSchema.editable === 1 ? "check" : "close"}</i>`
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (x) => formatTimestampHuman(x.updatedOn)
    }];
